import { useState } from 'react';
import { SITE_DOMAIN } from '../constants/site';

const faqs = [
  {
    q: 'How do I get help?',
    a: `Open live chat on ${SITE_DOMAIN} or submit the support form. We reply with clear, step-by-step guidance for your setup.`,
  },
  {
    q: 'Do you handle TreeVault sync issues?',
    a: 'Yes. We walk you through common TreeVault and multi-device sync scenarios, including reconnecting after a fresh install.',
  },
  {
    q: 'Will upgrading delete my existing tree?',
    a: 'A proper upgrade keeps your data intact. We always suggest a backup first, then help you verify everything after the update.',
  },
  {
    q: 'Is support available for both Windows and Mac?',
    a: 'Yes. Share your operating system when you reach out and we will tailor every instruction to your setup.',
  },
  {
    q: 'Is this the official Family Tree Maker website?',
    a: 'No. We are an independent third-party support resource and are not affiliated with or endorsed by Family Tree Maker trademark owners.',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="t7-section t7-section--white" id="faq">
      <div className="container max-w-3xl">
        <div className="t7-head t7-head--center">
          <p className="t7-kicker">Questions</p>
          <h2 className="t7-title t7-title--center">Answers before you reach out</h2>
        </div>

        <div className="space-y-3">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className="border border-[#c4d4ca] rounded-[10px] overflow-hidden bg-[#f4f7f5]"
              >
                <button
                  type="button"
                  className="w-full flex items-start justify-between gap-3 sm:gap-4 py-4 sm:py-5 px-4 sm:px-5 text-left bg-transparent border-0 cursor-pointer touch-manipulation"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                >
                  <span className="font-serif text-base sm:text-lg text-[#152019] pr-2">
                    {item.q}
                  </span>
                  <span className="text-[#2d6a4f] font-bold text-xl leading-none shrink-0 mt-0.5">
                    {isOpen ? '−' : '+'}
                  </span>
                </button>
                {isOpen && (
                  <p className="pb-4 sm:pb-5 px-4 sm:px-5 pt-0 text-sm sm:text-base text-[#55665c] leading-relaxed m-0 border-t border-[#c4d4ca]">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
